import React from 'react';
import Button from 'react-bootstrap/Button';
import EmployeeHolidayNode from './EmployeeholidayNode.js';
import {getholidaysbyid} from '../dbconnector/connector.js';
import { useState } from 'react';
import { useEffect } from 'react';
import { setErrorMessage } from '../tools/errorhandling.js';


const EmployeeHolidaysListNode = ({ t, user, events, viewOnly }) => {

   const [hollidays, setHollidays] = useState([]);

 useEffect(() => {
    getholidaysbyid(user.id).then((res) => {

        if (res.status === 200) {
            console.log(res);
            res.json().then((body) => {
                console.log(body);
                setHollidays(body);
            });
        }else{
            setErrorMessage(res.statusText);
        }

    });
    }, [user.id]);


return(
    <div id = "EmployeeHollidaysListNode" className='tabpanel UserTabs' >
        <div id="headertable" className="holidayheader_view">
                        <p id="startdatum">{t('Startdatum')}</p>
                        <p id="einddatum">{t('Einddatum')}</p>
                        <p id="reden">{t('Redenaanvraag')}</p>
                        <p id="status">{t('Status')}</p>
                    </div>
                    <div className="listHeight">
        {hollidays.map((holliday,index)=>{
             let cssname = "requested"
             if (holliday.status === 0) {
                 cssname = "requested"
             } else if (holliday.status === 1) {
                 cssname = "approved"
             }
             else {
                 cssname = "rejected"
             }
            return <EmployeeHolidayNode  cssname={cssname}index = {index} holliday={holliday} t={t} events={events} />
        })}
        </div>
    </div>
)
}

export default EmployeeHolidaysListNode;